const routes = {
    createReconcile: 'reconcile/create',
    submitReconcile: 'reconcile/update',
    updateReconcile: 'reconcile/update/entry',
    getReconcileList: 'reconcile',
    getReconcileApproval: 'reconcile/approve',
    getReconcileDetail: 'reconcile',
    deleteReconcile: 'reconcile/deleteEntry',
    deleteReconcileStatement: 'reconcile/statementEntry',
  };
  
  export default routes